export const ALLOWED_RUBI_ROLES = ['pavcon', 'base', 'organization-admin', 'organization-user', 'pavcon-user'] as const;

export function isAllowedRubiRole(normalizedRole: string): boolean {
  return (ALLOWED_RUBI_ROLES as readonly string[]).includes(
    normalizedRole.toLowerCase().trim()
  );
}
